import React from 'react';
import LogoImage from 'assets/images/LogoLabel.png';

class Logo extends React.Component {

    render() {
        const {width, height} = this.props;

        const dimensions = {
            ...(width) && {width},
            ...(height) && {height},
        };

        return (
            <img src={LogoImage} style={Object.assign(dimensions, {resizeMode: 'contains'})}/>
        )
    }
}

export default Logo;